<template>
    <div style="position: relative">
        <div :class="{'element': true, 'error': errors.has(label), 'focused':focused, 'required': required }" @click="placholderMobile = ''">
            <label :class="{'float': true, 'active': active}" :for="label">{{ label }}</label>
            <flat-pickr v-validate="required" v-model="value" :placeholder="label" :id="label" :name="label" :config="config" @on-change="setAge" @on-open="focused = true" @on-close="focused = false"></flat-pickr>
            <span v-show="errors.has(label)" class="error">{{ errors.first(label) }}</span>
            <input type="hidden" v-model="value" :name="label" :id="label">
        </div>

        <span class="placholder-mobile">{{placholderMobile}}</span>
    </div>
</template>
<script type='text/babel'>
    // import {flatDutch} from 'flatpickr/dist/l10n/nl.js';
    import element from '../../element'

    const flatDutch = require("flatpickr/dist/l10n/nl.js").default.nl;

    export default {
        mixins: [element],
        data: () => ({
            config: {
                altFormat: 'd-m-Y',
                altInput: true,
                allowInput: true,
                dateFormat: 'Y-m-d',
                maxDate: new Date(),
                locale: flatDutch,
                placholderMobile: '',
            },
        }),
        created(){
            this.placholderMobile = this.label
        },
        methods: {
            setAge(date, dateStr) {
                let age = this.getAge(dateStr)
                this.$store.dispatch('setAge', age)
            },
            getAge(date) {
                var birthday = new Date(date);
                var ageDifMs = Date.now() - birthday.getTime();
                var ageDate = new Date(ageDifMs); // miliseconds from epoch
                return Math.abs(ageDate.getUTCFullYear() - 1970);
            },
        }
    };
</script>
